import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = {
  id: "couponPrint",
  class: "row coupon-wrapper no-gutters"
}
const _hoisted_3 = { class: "col col-12 col-md-10 offset-md-1" }
const _hoisted_4 = { class: "card my-2" }
const _hoisted_5 = {
  class: "container",
  style: {}
}
const _hoisted_6 = { class: "row no-gutters px-4 py-4 align-items-end" }
const _hoisted_7 = { class: "col-12" }
const _hoisted_8 = {
  class: "h1 card-title",
  style: {"color":"var(--primary-color)","font-weight":"bold"}
}
const _hoisted_9 = { class: "" }
const _hoisted_10 = {
  class: "p-3 mb-3 border rounded",
  style: {"background-color":"var(--background-color-light)"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_back_to_previous_page = _resolveComponent("back-to-previous-page")!
  const _component_contact = _resolveComponent("contact")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["alert alert-success alert-dismissible mail-alert", { 'show-alert': _ctx.mailSent || _ctx.smsSent }])
    }, [
      _createVNode(_component_router_link, {
        to: "#",
        class: "btn-close",
        onClick: _ctx.closeAlert
      }, null, 8, ["onClick"]),
      _cache[0] || (_cache[0] = _createElementVNode("span", { class: "notification-text" }, "Message sent.", -1))
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["alert alert-danger alert-dismissible mail-alert", { 'show-alert': _ctx.mailSendFailure || _ctx.smsSendFailure }])
    }, [
      _createVNode(_component_router_link, {
        to: "#",
        class: "btn-close text-dark",
        onClick: _ctx.closeAlert
      }, null, 8, ["onClick"]),
      _cache[1] || (_cache[1] = _createElementVNode("span", { class: "danger-text" }, "Failed to send message.", -1))
    ], 2),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_back_to_previous_page, {
        class: "col-12 col-md-10 offset-md-1",
        returnURL: _ctx.returnURL,
        backText: "Back to Search Results"
      }, null, 8, ["returnURL"]),
      _cache[9] || (_cache[9] = _createElementVNode("h1", { class: "h2 col-12 col-md-10 offset-md-1 text-center" }, [
        _createElementVNode("b", { class: "lead" }, "Acquire an alternative prescription to save")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("h2", _hoisted_8, _toDisplayString(_ctx.alternativeMedication.drugName) + " Therapeutic Alternative ", 1),
                _createElementVNode("p", null, [
                  _cache[3] || (_cache[3] = _createTextVNode("You may be able to take ", -1)),
                  _createVNode(_component_router_link, {
                    to: '/' + _ctx.alternativeMedication.alternativeDrugName
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("b", null, _toDisplayString(_ctx.alternativeMedication.alternativeDrugName), 1)
                    ]),
                    _: 1
                  }, 8, ["to"]),
                  _createTextVNode(" instead of " + _toDisplayString(_ctx.alternativeMedication.drugName) + " to treat your diagnosis. ", 1),
                  _createVNode(_component_router_link, {
                    to: '/' + _ctx.alternativeMedication.alternativeDrugName
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("b", null, _toDisplayString(_ctx.alternativeMedication.alternativeDrugName), 1)
                    ]),
                    _: 1
                  }, 8, ["to"]),
                  _createTextVNode(" is less expensive than " + _toDisplayString(_ctx.alternativeMedication.drugName) + " - ", 1),
                  _createVNode(_component_router_link, {
                    to: '/' + _ctx.alternativeMedication.alternativeDrugName
                  }, {
                    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                      _createTextVNode("see prices here", -1)
                    ]))]),
                    _: 1
                  }, 8, ["to"]),
                  _createTextVNode(". Unfortunately, taking " + _toDisplayString(_ctx.alternativeMedication.alternativeDrugName) + " may not be as safe or effective as taking " + _toDisplayString(_ctx.alternativeMedication.drugName) + ". ", 1)
                ]),
                _createElementVNode("p", null, " To get started with " + _toDisplayString(_ctx.alternativeMedication.alternativeDrugName) + " you will need a new prescription, which means contacting your doctor. Alternatively, you can contact IntelligentRx's pharmacist to discuss your options:", 1),
                _createElementVNode("div", _hoisted_9, [
                  _cache[5] || (_cache[5] = _createElementVNode("div", {
                    class: "p-3 mb-3 border rounded",
                    style: {"background-color":"var(--background-color-light)"}
                  }, [
                    _createElementVNode("h3", { class: "h5" }, "Call IntelligentRx For Help"),
                    _createElementVNode("p", null, [
                      _createElementVNode("a", {
                        class: "btn irx-btn-primary irx-btn-primary-animated w-100 btn-lg",
                        href: "tel:1-800-484-3487"
                      }, " 1-800-484-3487 ")
                    ])
                  ], -1)),
                  _createElementVNode("div", _hoisted_10, [
                    _cache[4] || (_cache[4] = _createElementVNode("h3", { class: "h5" }, "Email IntelligentRx With General Questions", -1)),
                    _createVNode(_component_contact)
                  ])
                ]),
                _cache[6] || (_cache[6] = _createElementVNode("hr", null, null, -1)),
                _cache[7] || (_cache[7] = _createElementVNode("h2", {
                  class: "h1 card-title",
                  style: {"color":"var(--primary-color)","font-weight":"bold"}
                }, " Therapeutic Alternative FAQ ", -1)),
                _cache[8] || (_cache[8] = _createElementVNode("p", null, [
                  _createElementVNode("b", null, "What is a therapeutic alternative?"),
                  _createTextVNode(" There are often multiple prescription medications which treat a diagnosis. These different medications might be grouped into the same \"drug class\", which is a group of drugs which work similarly or treat similar conditions. It is often (but not always) possible to substitute one drug in a drug class for another drug in the same drug class, so you can use drug classes as a starting point to check if there are cheaper Rx treatment options.")
                ], -1))
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}